(() => {
  if (window.MayLondonStyleStudio) return;
  window.MayLondonStyleStudio = true;
  const E = window.MayLondonStyleEngine, C = window.MayLondonStyleCatalog, I = window.MayLondonI18n, L = window.MayLondonLookbook;
  if (!E || !C || !I || !L) return;
  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const strings = JSON.parse(root.querySelector('[data-studio-strings]').textContent);
    const t = key => strings[key] || key, find = name => root.querySelector('[data-studio-' + name + ']');
    const libraryStrings = JSON.parse(find('library-strings').textContent);
    const lt = (key, values = {}) => (libraryStrings[key] || key).replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match);
    const key = 'may-london-style-studio-v1';
    let products = [], lines = [], saved = [], own = [], history = [], results = [], limit = 12, busy = false, editing = '', editOwn = '', cartItems = [], cartReady = false;
    let capsule, travel, quiz, resultRelaxed = [];
    const node = (tag, text, className) => { const el = document.createElement(tag); if (text != null) el.textContent = text; if (className) el.className = className; return el; };
    const message = text => { find('status').textContent = text; };
    const button = (text, fn) => { const el = node('button', text); el.type = 'button'; el.addEventListener('click', fn); return el; };
    const readSizes = form => { const data = new FormData(form), sizes = data.getAll('sizes'); return {sizes, size:sizes.length ? '' : String(data.get('size') || '').trim()}; };
    const filters = () => { const form=find('filters'),data = {...Object.fromEntries(new FormData(form)), ...readSizes(form)}; data.budget = Math.round(Number(data.budget || 0) * 100); return data; };
    const identify = line => line.kind === 'own' ? own.find(p => p.id === line.id) : products.find(p => p.handle === line.handle);
    function image(product) {
      const blank = node('div', '', 'style-studio__image');
      if (!product?.image) return blank;
      try {
        const url = new URL(product.image, location.origin);
        if (url.origin !== location.origin && (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com')) return blank;
        const img = node('img'); img.src = url.href; img.alt = product.title || product.name; img.width = 480; img.height = 640; img.loading = 'lazy';
        img.addEventListener('error', () => img.replaceWith(blank), {once: true}); return img;
      } catch (_) { return blank; }
    }
    function zoomImage(product) {
      const picture = image(product);
      if (picture.tagName !== 'IMG') return picture;
      const trigger = node('button', null, 'style-studio__zoom-trigger');
      trigger.type = 'button'; trigger.dataset.studioImageZoom = '';
      trigger.setAttribute('aria-label', t('zoom') + ': ' + (product.title || product.name));
      trigger.setAttribute('aria-haspopup', 'dialog'); trigger.append(picture);
      return trigger;
    }
    function selectionImage(product, checked, change) {
      const label=node('label',null,'style-studio__image-choice'),input=node('input');
      input.type='checkbox';input.value=product.handle;input.checked=checked;input.setAttribute('aria-label',product.title);
      input.addEventListener('change',()=>change(input));
      const frame=node('span',null,'style-studio__choice-frame'),picture=image(product);
      if(picture.tagName==='IMG')picture.alt='';frame.append(picture);
      label.append(input,frame,node('span',product.title,'style-studio__choice-name'));return label;
    }
    const zoomEvents = new AbortController();
    const sizePickers = [...root.querySelectorAll('input[name="size"]')].map(input => {
      const original=input.closest('label'), field=node('div',null,'style-studio__size-picker'), menu=node('details',null,'style-studio__size-menu');
      const summary=node('summary'), choices=node('div',null,'style-studio__size-options');
      summary.setAttribute('aria-label',t('select_sizes'));summary.title=t('select_sizes');summary.append(root.querySelector('[data-studio-size-icon]').content.cloneNode(true));
      original.replaceWith(field);field.append(original,menu);menu.append(summary,choices);
      input.addEventListener('input',()=>{choices.querySelectorAll('input').forEach(box=>{box.checked=false;});});
      menu.addEventListener('change',()=>{input.value=[...choices.querySelectorAll('input:checked')].map(box=>box.value).join(', ');});
      menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;summary.focus();event.preventDefault();}});
      document.addEventListener('click',event=>{if(!field.contains(event.target))menu.open=false;},{signal:zoomEvents.signal});
      return {input,choices};
    });
    function refreshSizes() {
      const available=E.sizeChoices(products);
      for(const {choices} of sizePickers){
        const selected=new Set([...choices.querySelectorAll('input:checked')].map(box=>box.value));choices.replaceChildren();
        for(const value of [...new Set([...available,...selected])]){
          const label=node('label'),box=node('input');box.type='checkbox';box.name='sizes';box.value=value;box.checked=selected.has(value);
          label.append(box,node('span',value));choices.append(label);
        }
        if(!available.length)choices.append(node('p',t('empty')));
      }
    }
    const zoomDialog = node('dialog', null, 'style-studio__zoom-dialog');
    const zoomClose = button('', () => zoomDialog.close());
    zoomClose.className = 'style-studio__zoom-close'; zoomClose.setAttribute('aria-label', t('close')); zoomClose.title = t('close');
    zoomClose.append(find('icon').content.cloneNode(true));
    const zoomContent = node('div', null, 'style-studio__zoom-content');
    zoomDialog.append(zoomClose, zoomContent); root.append(zoomDialog);
    let zoomOrigin = null;
    function enlargedPhoto(trigger) {
      const original = trigger.querySelector('img');
      if (!original || (original.complete && !original.naturalWidth)) return null;
      const picture = original.cloneNode(false), url = new URL(original.src, location.origin);
      if (url.hostname === 'cdn.shopify.com' || url.pathname.startsWith('/cdn/shop/')) url.searchParams.set('width', '960');
      picture.removeAttribute('srcset'); picture.src = url.href; picture.loading = 'eager';
      return picture;
    }
    root.addEventListener('click', event => {
      const trigger=event.target.closest('[data-studio-image-zoom]'); if (!trigger) return;
      const picture=enlargedPhoto(trigger); if (!picture) return;
      zoomOrigin=trigger; zoomDialog.setAttribute('aria-label', picture.alt); zoomContent.replaceChildren(picture);
      picture.addEventListener('error', () => { zoomDialog.close(); message(t('error')); }, {once:true});
      zoomDialog.showModal(); document.body.classList.add('ml-studio-zoom-open'); zoomClose.focus();
    }, {signal:zoomEvents.signal});
    zoomDialog.addEventListener('click', event => {
      if (event.target !== zoomDialog) return;
      const rect=zoomDialog.getBoundingClientRect();
      if (event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom) zoomDialog.close();
    });
    zoomDialog.addEventListener('close', () => { document.body.classList.remove('ml-studio-zoom-open'); zoomContent.replaceChildren(); if (zoomOrigin?.isConnected) zoomOrigin.focus({preventScroll:true}); });
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) { zoomDialog.close(); zoomEvents.abort(); } }, {signal:zoomEvents.signal});
    const label = (text, control) => { const el = node('label', text); el.append(control); return el; };
    const option = (value, text, disabled = false) => { const el = node('option', text); el.value = value; el.disabled = disabled; return el; };
    const keep = () => {
      try {
        if (find('remember').checked) localStorage.setItem(key, JSON.stringify({version: 1, lines, saved, own}));
        else localStorage.removeItem(key);
        return true;
      } catch (_) { message(t('storage_error')); return false; }
    };
    const snapshot = () => { history.push(structuredClone(lines)); if (history.length > 20) history.shift(); };
    const apply = next => { snapshot(); lines = next.map(l => ({...l})); renderLook(); keep(); };
    function tab(name) {
      if (['capsule','travel','quiz'].includes(name) && !busy) message('');
      root.querySelectorAll('[data-studio-panel]').forEach(el => { el.hidden = el.dataset.studioPanel !== name; });
      root.querySelectorAll('[data-studio-tab]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.studioTab === name)));
    }
    function refreshControls() {
      const values = filters();
      for (const field of ['category', 'season', 'occasion', 'style']) {
        const select = find('filters').elements[field];
        const options = [...new Set(products.filter(p => E.matches(p)).flatMap(p => field === 'category' ? [p.category] : E.facts(p, field)))].filter(Boolean).sort();
        select.replaceChildren(option('', t('all')), ...options.map(value => option(value, strings[value] || value)));
        select.value = options.includes(values[field]) ? values[field] : '';
        select.disabled = !options.length;
      }
    }
    function browse() {
      const list = find('catalog'), selection=E.collection(availableProducts(),filters()), candidates=selection.items;
      list.replaceChildren();
      if(selection.relaxed.length)list.append(node('p',alternativeText(selection.relaxed),'style-studio__alternatives'));
      if (!candidates.length) list.append(node('p', t('empty')));
      candidates.slice(0, limit).forEach(product => {
        const article = node('article', null, 'style-studio__piece');
        const link = node('a', product.title); link.href = I.route('/products/' + encodeURIComponent(product.handle));
        const add = button(t('include'), () => {
          if (lines.length >= 20) return message(t('limit'));
          apply([...lines, {kind: 'shop', handle: product.handle, variantId: product.variants.length === 1 && product.variants[0].title === 'Default Title' ? String(product.variants[0].id) : '', quantity: 1}]);
          message(t('choose_options'));
        });
        article.append(image(product), link, C.colours(product), node('strong', I.money(E.price(product, selection.filters))), add); list.append(article);
      });
      find('more').hidden = limit >= candidates.length;
    }
    function remaining(variant, excluded) {
      const count = lines.reduce((n, line, index) => n + (index !== excluded && String(line.variantId) === String(variant.id) ? line.quantity : 0), 0);
      const inCart = cartItems.reduce((n, item) => n + (String(item.variant_id) === String(variant.id) ? item.quantity : 0), 0);
      return Math.max(0, E.capacity(variant) - count - inCart);
    }
    function renderLook() {
      const container = find('lines'); container.replaceChildren();
      if (!lines.length) container.append(node('p', t('choose_items')));
      lines.forEach((line, index) => {
        const product = identify(line), article = node('article', null, 'style-studio__line'), content = node('div');
        article.append(zoomImage(product)); content.append(node('h3', product?.title || product?.name || t('unavailable')));
        if (line.kind === 'own') content.append(node('p', t('own')));
        else if (product) {
          const select = node('select'); select.append(option('', t('choose_options')));
          product.variants.forEach(variant => {
            const available = remaining(variant, index) >= line.quantity;
            select.append(option(String(variant.id), `${variant.title === 'Default Title' ? product.title : variant.title} - ${I.money(variant.price)}${available ? '' : ' - ' + t('unavailable')}`, !available));
          });
          select.value = String(line.variantId || '');
          select.addEventListener('change', () => { snapshot(); line.variantId = select.value; renderLook(); keep(); });
          content.append(label(t('choose_options'), select));
          const quantity = node('input'); quantity.type = 'number'; quantity.min = '1'; quantity.step = '1'; quantity.value = line.quantity;
          const variant = E.variantFor(product, line.variantId), maximum = variant ? remaining(variant, index) : 0;
          quantity.max = String(Math.min(99, maximum)); quantity.disabled = !variant || maximum < 1;
          quantity.addEventListener('change', () => {
            const count = Number(quantity.value);
            if (!Number.isSafeInteger(count) || count < 1 || count > Math.min(99, maximum)) { quantity.value = line.quantity; message(t('stock_changed')); return; }
            snapshot(); line.quantity = count; renderLook(); keep();
          }); content.append(label(t('qty'), quantity));
          if (variant && maximum < line.quantity) content.append(node('p', t('stock_changed')));
        } else content.append(node('p', t('unavailable')));
        const remove = button('', () => { snapshot(); lines.splice(index, 1); renderLook(); keep(); });
        remove.dataset.remove = ''; remove.setAttribute('aria-label', t('remove') + ': ' + (product?.title || product?.name || '')); remove.title = t('remove');
        remove.append(find('icon').content.cloneNode(true)); article.append(content, remove); container.append(article);
      });
      const check = E.validate(lines, products, cartItems);
      find('total').textContent = check.valid ? I.money(check.subtotal) : t(check.reason);
      find('add').disabled = !check.valid || busy || !cartReady;
      root.querySelector('[data-studio-action="undo"]').disabled = !history.length;
    }
    function previews(container, values) {
      const strip = node('div', null, 'style-studio__previews');
      values.slice(0, 5).forEach(line => { const p = identify(line); if (p?.image) strip.append(zoomImage(p)); }); container.append(strip);
    }
    function editState() {
      const look = saved.find(item => item.id === editing);
      if (!look) editing = '';
      find('editing').hidden = !editing;
      find('editing').textContent = look ? lt('editing', {name:look.name}) : '';
      find('save-label').textContent = editing ? lt('update') : t('save');
      find('save-copy').hidden = find('stop-editing').hidden = !editing;
    }
    function finishEditing() { editing = ''; find('save').reset(); editState(); }
    function confirm(title, description, actions, origin) {
      const dialog = find('confirm');
      find('confirm-title').textContent = title; find('confirm-text').textContent = description;
      const controls = actions.map(action => button(action.label, () => { dialog.close(); action.run?.(); }));
      find('confirm-actions').replaceChildren(...controls);
      dialog.onclose = () => {
        if (origin?.isConnected && origin.getClientRects().length) origin.focus({preventScroll:true});
        else if (!root.querySelector('[data-studio-panel="saved"]').hidden) find('saved-filters').elements.query.focus({preventScroll:true});
      };
      dialog.showModal(); controls[0].focus();
    }
    function openSaved(look, reuse) {
      editing = look.id; const form = find('save');
      form.elements.name.value = look.name;
      if (look.metadata.season && ![...form.elements.season.options].some(item => item.value === look.metadata.season)) form.elements.season.add(option(look.metadata.season, strings[look.metadata.season] || look.metadata.season));
      form.elements.season.value = look.metadata.season; form.elements.occasion.value = look.metadata.occasion;
      const filterForm = find('filters'); filterForm.reset();
      for (const [field,value] of Object.entries(L.preferences(look.preferences))) if (filterForm.elements[field]) filterForm.elements[field].value = field === 'budget' ? value / 100 : value;
      browse(); apply(L.lines(look.lines, reuse)); editState(); tab('build'); message(t('restored'));
      find('lines').scrollIntoView({block:'center',behavior:'instant'});
      find('lines').querySelector('select,button')?.focus();
    }
    function renderSaved() {
      const list = find('saved'); list.replaceChildren();
      const form = find('saved-filters');
      for (const field of ['season','occasion']) {
        const select = form.elements[field], value = select.value;
        const values = [...new Set(saved.map(look => look.metadata[field]).filter(Boolean))].sort();
        select.replaceChildren(option('', t('all')), ...values.map(value => option(value, strings[value] || value)));
        select.value = values.includes(value) ? value : '';
      }
      const matches = L.search(saved, Object.fromEntries(new FormData(form)), products, own);
      find('saved-count').textContent = lt('count', {count:I.number(matches.length), total:I.number(saved.length)});
      if (!matches.length) list.append(node('p', saved.length ? lt('empty') : t('empty')));
      matches.forEach(look => {
        const article = node('article'); article.dataset.lookId = look.id;
        article.append(node('h3', look.name), node('p', [strings[look.metadata.season] || look.metadata.season, look.metadata.occasion].filter(Boolean).join(' / ')));
        previews(article, look.lines);
        const items = node('ul');
        look.lines.forEach(line => {
          const product = identify(line), variant = product && line.kind === 'shop' ? E.variantFor(product, line.variantId) : null;
          const item = node('li', (product?.title || product?.name || t('unavailable')) + (line.quantity > 1 ? ' (' + I.number(line.quantity) + ')' : ''));
          item.append(node('small', line.kind === 'own' ? [t('own'),product?.colour].filter(Boolean).join(' / ') : variant?.title || lt('needs_options')));
          items.append(item);
        });
        article.append(items);
        const hasShop = look.lines.some(line => line.kind === 'shop');
        if (hasShop && cartReady) {
          const check = E.validate(look.lines, products, cartItems);
          if (!check.valid) article.append(node('p', t(check.reason)));
        }
        article.append(node('p', !look.lines.length ? t('choose_items') : hasShop ? lt('stock_note') : lt('owned_only'), 'style-studio__note'));
        const actions = node('div', null, 'style-studio__actions');
        const open = button(t('load'), () => {
          if (busy) return;
          if (look.lines.some(line => line.kind === 'shop' && line.variantId)) confirm(lt('reuse_title'), lt('reuse_text'), [
            {label:lt('choose_again'), run:() => openSaved(look, false)},
            {label:lt('reuse'), run:() => openSaved(look, true)},
            {label:lt('cancel')}
          ], open);
          else openSaved(look, false);
        });
        const remove = button(t('remove'), () => confirm(lt('delete_title'), lt('delete_text',{name:look.name}), [
          {label:lt('cancel')}, {label:t('remove'), run:() => {
            saved = saved.filter(item => item.id !== look.id);
            if (editing === look.id) finishEditing();
            if (keep()) message(lt('deleted'));
            renderSaved();
          }}
        ], remove));
        actions.append(open, remove); article.append(actions);
        list.append(article);
      });
    }
    function renderWardrobe() {
      capsule?.refresh();
      travel?.refresh();
      const list = find('wardrobe'); list.replaceChildren();
      if (!own.length) list.append(node('p', t('empty')));
      own.forEach(item => {
        const article = node('article'); article.append(node('h3', item.name), node('p', [t(item.category), item.colour].filter(Boolean).join(' / ')));
        article.append(button(t('include'), () => { if (lines.length >= 20) return message(t('limit')); apply([...lines, {kind:'own', id:item.id, quantity:1}]); tab('build'); }),
          button(t('edit'), () => { editOwn = item.id; const form = find('wardrobe-form'); for (const field of ['name','category','colour']) form.elements[field].value = item[field]; form.elements.name.focus(); }),
          button(t('remove'), () => { own = own.filter(p => p.id !== item.id); lines = lines.filter(l => l.kind !== 'own' || l.id !== item.id); saved.forEach(s => { s.lines = s.lines.filter(l => l.kind !== 'own' || l.id !== item.id); }); history = []; if (editOwn === item.id) { editOwn = ''; find('wardrobe-form').reset(); } keep(); renderWardrobe(); renderSaved(); renderLook(); }));
        list.append(article);
      });
    }
    function renderSuggestions() {
      find('suggestions').replaceChildren();
      if(resultRelaxed.length)find('suggestions').append(node('p',alternativeText(resultRelaxed),'style-studio__alternatives'));
      results.forEach((look, index) => {
        const article = node('article'); article.append(node('h3', `${t('your_look')} ${I.number(index + 1)}`)); previews(article, look.lines);
        article.append(node('p', I.money(look.subtotal)), button(t('load'), () => { finishEditing(); apply(look.lines); message(t('choose_options')); })); find('suggestions').append(article);
      });
    }
    function alternativeText(fields) { return t('alternatives')+' '+fields.map(field=>t('alternative_'+field)).join(' '); }
    function availableProducts() {
      return products.map(product=>({...product,variants:product.variants.map(variant=>{
        const reserved=cartItems.reduce((sum,line)=>sum+(String(line.variant_id)===String(variant.id)?line.quantity:0),0),remaining=E.capacity(variant)-reserved;
        return {...variant,available:variant.available&&remaining>0,inventory:Number.isFinite(remaining)?remaining:variant.inventory};
      })}));
    }
    function suggest(options) {
      const proposed=E.recommendations(availableProducts(),filters(),options);results=proposed.items;resultRelaxed=proposed.relaxed;renderSuggestions();
    }
    async function cart() {
      cartReady = false;
      const response = await fetch(I.route('/cart.js'), {cache:'no-store', signal:AbortSignal.timeout(10000)});
      if (!response.ok) throw new Error('cart');
      const data = await response.json();
      if (!Array.isArray(data.items) || (data.currency && data.currency !== JSON.parse(document.getElementById('MayLondonConfig').textContent).currency)) throw new Error('currency');
      cartItems = data.items; cartReady = true; return data;
    }
    async function load() {
      busy = true; find('retry').hidden = true; message(t('loading'));
      try {
        if (!root.dataset.catalog) throw new Error('catalogue');
        const data = await C.catalogue(root.dataset.catalog, {refresh:true});
        const currency = JSON.parse(document.getElementById('MayLondonConfig').textContent).currency;
        if (data.currency !== currency) throw new Error('currency');
        products = data.products; await cart(); refreshSizes(); refreshControls(); browse(); renderSaved(); renderWardrobe(); message(data.complete ? '' : t('partial'));
      } catch (_) { find('retry').hidden = false; message(t('error')); }
      finally { busy = false; renderLook(); renderSaved(); capsule?.refresh(); travel?.refresh(); quiz?.refresh(); }
    }
    find('add').addEventListener('click', async () => {
      if (busy) return;
      busy = true; root.setAttribute('aria-busy', 'true'); find('add').disabled = true; message(t('loading'));
      // Freeze the request. Edits made while Shopify responds must never change the submitted variant set.
      const pending = structuredClone(lines); let sent = false;
      try {
        await cart();
        for (const handle of new Set(pending.filter(l => l.kind !== 'own').map(l => l.handle))) {
          const fresh = await C.product(handle);
          const index = products.findIndex(p => p.handle === handle);
          if (!E.validProduct(fresh) || fresh.handle !== handle || index < 0) throw new Error('product');
          products[index] = fresh;
        }
        const check = E.validate(pending, products, cartItems);
        if (!check.valid) { message(t(check.reason)); return; }
        const response = await fetch(I.route('/cart/add.js'), {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:check.items}), signal:AbortSignal.timeout(20000)});
        if (!response.ok) { await cart(); message(t('stock_changed')); return; }
        sent = true;
        await cart(); message(t('added'));
        document.dispatchEvent(new CustomEvent('may-london:cart-refresh'));
        window.MayLondonTrack?.('add_to_cart', {value:check.subtotal/100, items:check.items.map(item => ({item_id:String(item.id), quantity:item.quantity}))});
      } catch (_) {
        // A timed-out POST may have committed. Refresh the bag before allowing another attempt.
        try { await cart(); } catch (_) { cartReady = false; find('retry').hidden = false; }
        message(sent ? I.t('added_refresh') : I.t('cart_check_before_retry'));
        document.dispatchEvent(new CustomEvent('may-london:cart-refresh'));
      } finally { busy = false; root.removeAttribute('aria-busy'); renderLook(); renderSaved(); capsule?.refresh(); travel?.refresh(); quiz?.refresh(); }
    });
    find('filters').addEventListener('submit', event => event.preventDefault());
    find('filters').addEventListener('input', () => { limit = 12; browse(); });
    document.addEventListener('maylondon:stylist-piece', event => {
      if (busy || lines.length >= 20 || typeof event.detail?.handle !== 'string') return;
      const product = products.find(item => item.handle === event.detail.handle);
      if (!product || !E.matches(product)) return;
      apply([...lines, {kind:'shop', handle:product.handle, variantId:'', quantity:1}]);
      tab('build'); message(t('choose_options')); event.preventDefault();
      root.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    }, {signal:zoomEvents.signal});
    document.addEventListener('maylondon:stylist-preferences', event => {
      const detail = event.detail;
      if (busy || detail?.version !== 1 || detail.source !== 'v19-stylist' || detail.consent?.useInBuilder !== true) return;
      const preferences = detail.preferences, form = find('filters');
      if (!preferences || typeof preferences.size !== 'string' || preferences.size.length > 24) return;
      for (const field of ['style', 'occasion']) {
        const value = typeof preferences[field] === 'string' ? preferences[field].slice(0,40) : '';
        const select = form.elements[field];
        if (value && ![...select.options].some(item => item.value === value)) {
          const label = document.querySelector('[data-v19-stylist] [data-stylist-strings]');
          const translations = label ? JSON.parse(label.textContent) : {};
          select.add(option(value, translations[value] || value));
        }
        select.disabled = false; select.value = value;
      }
      form.elements.size.value = preferences.size;
      form.querySelectorAll('[name="sizes"]').forEach(box=>{box.checked=false;});
      form.elements.query.value = typeof preferences.notes === 'string' ? preferences.notes.slice(0,500) : '';
      limit = 12; tab('build'); browse();
      suggest({own, limit:5});
      if(results.length && !lines.length) apply(results[0].lines);
      message(results.length ? t('choose_options') : t('no_suggestions'));
      event.preventDefault();
      root.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start'});
    }, {signal:zoomEvents.signal});
    document.querySelectorAll('[data-studio-destination]').forEach(link => link.addEventListener('click', () => tab(link.dataset.studioDestination), {signal:zoomEvents.signal}));
    find('more').addEventListener('click', () => { limit += 12; browse(); });
    find('retry').addEventListener('click', load);
    root.querySelectorAll('[data-studio-tab]').forEach(el => el.addEventListener('click', () => tab(el.dataset.studioTab)));
    root.querySelectorAll('[data-studio-action]').forEach(el => el.addEventListener('click', () => {
      if (busy) return;
      const action = el.dataset.studioAction;
      if (action === 'undo') { if (history.length) { lines = history.pop(); renderLook(); keep(); } return; }
      if (action === 'cheaper') {
        const next = E.cheaper(lines, products, filters());
        if (JSON.stringify(next) === JSON.stringify(lines)) return message(t('no_cheaper'));
        apply(next); message(t('choose_options')); return;
      }
      if (action !== 'suggest' && !lines.length) return message(t('choose_anchor'));
      const anchor = action === 'five' ? [lines[0]] : action === 'evening' ? lines.filter(l => E.baseCategories.has(identify(l)?.category)) : [];
      if (action === 'evening' && !anchor.length) return message(t('choose_anchor'));
      suggest({anchor, own, limit:5});
      message(results.length ? t('choose_options') : t('no_suggestions'));
    }));
    find('save').addEventListener('submit', event => {
      event.preventDefault(); const name = event.target.elements.name.value.trim().slice(0,80);
      if (!lines.length || !name) return message(t('choose_items'));
      const target = event.submitter?.value === 'copy' ? '' : editing;
      if (saved.length >= 30 && !target) return message(t('limit'));
      const value = L.normalize({id:target || crypto.randomUUID(), name, lines, preferences:filters(), metadata:{season:event.target.elements.season.value,occasion:event.target.elements.occasion.value}});
      saved = saved.filter(item => item.id !== target); saved.push(value);
      finishEditing(); const persisted = keep(); renderSaved();
      if (persisted) message(t('save_done') + ' ' + lt(find('remember').checked ? 'device' : 'session'));
    });
    find('stop-editing').addEventListener('click', finishEditing);
    find('saved-filters').addEventListener('submit', event => event.preventDefault());
    find('saved-filters').addEventListener('input', renderSaved);
    find('saved-filters').addEventListener('reset', event => {
      event.preventDefault();
      for (const field of ['query','season','occasion','source']) event.target.elements[field].value = '';
      event.target.elements.sort.value = 'recent'; renderSaved();
    });
    find('wardrobe-form').elements.category.replaceChildren(...E.categories.map(value => option(value, t(value))));
    find('wardrobe-form').addEventListener('submit', event => {
      event.preventDefault(); const data = Object.fromEntries(new FormData(event.target));
      if (!data.name.trim() || !E.categories.includes(data.category)) return;
      if (own.length >= 100 && !editOwn) return message(t('limit'));
      const item = {id:editOwn || crypto.randomUUID(), name:data.name.trim().slice(0,80), category:data.category, colour:data.colour.trim().slice(0,40)};
      const index = own.findIndex(p => p.id === editOwn); if (index >= 0) own[index] = item; else own.push(item);
      editOwn = ''; event.target.reset(); const persisted = keep(); renderWardrobe(); renderSaved(); renderLook(); if (persisted) message(t('save_done'));
    });
    find('remember').addEventListener('change', keep);
    find('clear').addEventListener('click', () => { lines = []; saved = []; own = []; history = []; results = []; resultRelaxed = []; editOwn = ''; finishEditing(); find('remember').checked = false; find('saved-filters').reset(); find('wardrobe-form').reset(); const persisted = keep(); renderLook(); renderSaved(); renderWardrobe(); renderSuggestions(); if (persisted) message(''); });
    try {
      const stored = localStorage.getItem(key);
      if (stored && stored.length <= 200000) {
        const data = JSON.parse(stored);
        if (data?.version === 1 && Array.isArray(data.lines) && Array.isArray(data.saved) && Array.isArray(data.own)) {
          lines = L.lines(data.lines, false);
          saved = L.restore(data.saved);
          own = data.own.filter(item => item && typeof item.id === 'string' && typeof item.name === 'string' && E.categories.includes(item.category)).slice(0,100).map(item => ({id:item.id, name:item.name.slice(0,80), category:item.category, colour:String(item.colour || '').slice(0,40)}));
          find('remember').checked = true;
        }
      }
    } catch (_) { message(t('storage_error')); }
    if (location.hash === '#fitting-room') {
      const fittingLink = document.querySelector('[data-fitting-room-link], a[href*="/pages/fitting-room"]');
      if (fittingLink) location.replace(fittingLink.href);
    }
    const plannerOptions = {
      state: () => ({products, own, cart:cartItems, ready:cartReady && !busy && find('retry').hidden}),
      open: next => { if (busy || !next.length) return; finishEditing(); apply(next); tab('build'); message(t('choose_options')); find('lines').scrollIntoView({block:'center',behavior:'instant'}); find('lines').querySelector('select,button')?.focus(); },
      image:zoomImage, selectionImage, readSizes, preview:previews
    };
    capsule = window.MayLondonCapsuleUI?.initialize(root, plannerOptions);
    travel = window.MayLondonTravelUI?.initialize(root, plannerOptions);
    quiz = window.MayLondonStyleQuizUI?.initialize(root, plannerOptions);
    find('clear').addEventListener('click', () => { capsule?.clear(); travel?.clear(); quiz?.clear(); });
    if (location.hash === '#capsule-wardrobe') tab('capsule');
    if (location.hash === '#travel-wardrobe') tab('travel');
    if (location.hash === '#discover-style') tab('quiz');
    if (location.hash === '#personal-lookbook') tab('saved');
    renderSaved(); editState();
    load();
  };
  document.querySelectorAll('[data-style-studio]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-style-studio]').forEach(initialize));
})();
